import React from "react";
import { CreditCardIcon, FileDownIcon, ShieldCheckIcon } from "lucide-react";
import { Container, CtaButton } from "./ui";
import { images } from "../data/content";
const trust = [{
  icon: FileDownIcon,
  label: "PDF download"
}, {
  icon: CreditCardIcon,
  label: "One-time payment"
}, {
  icon: ShieldCheckIcon,
  label: "10-day guarantee"
}];
export function Hero() {
  return <header id="hero" className="bg-cream text-ink" data-id="element-82" data-mp="1297cu5rar3ad">
      <Container className="flex min-h-[100svh] flex-col py-8 lg:grid lg:grid-cols-[1.1fr_1fr] lg:items-center lg:gap-x-12 lg:gap-y-8 lg:py-12" data-id="element-83" data-mp="128z14h6wu40r">
        {/* Badge + headline */}
        <div className="text-center lg:col-start-1 lg:row-start-1 lg:self-end lg:text-left" data-id="element-84" data-mp="sa9nj0m1r5qb">
          <p className="inline-flex items-center gap-2 rounded-full border border-petrol/40 px-4 py-2 text-[11px] font-semibold uppercase tracking-[0.16em] text-petrol sm:text-xs" data-id="element-85" data-mp="nb6l7nxgbdm1">
            <span className="h-1.5 w-1.5 shrink-0 rounded-full bg-petrol" aria-hidden="true" data-id="element-86" data-mp="381xl8y8vx2a6" />
            For senior living activity directors
          </p>
          <h1 className="mt-4 font-display text-[clamp(36px,10vw,54px)] font-extrabold uppercase leading-[0.95] tracking-[-0.01em] lg:mt-6 lg:text-[clamp(56px,5.6vw,82px)]" data-id="element-87" data-mp="3j6fwnlhhz5bq">
            Plan your entire activity year <span className="text-petrol" data-id="element-88" data-mp="39cpcgsselh1u">in under 5 minutes.</span>
          </h1>
        </div>

        {/* Mockup */}
        <div className="flex flex-1 items-center justify-center py-6 lg:col-start-2 lg:row-span-2 lg:row-start-1 lg:py-0" data-id="element-89" data-mp="30iaziwvciilw">
          <img src={images.boxMockup} alt="The Activity Director’s Year-Round Kit box set with its activity book and five bonus resources" className="max-h-[46svh] w-auto max-w-full rounded-2xl shadow-[0_24px_50px_rgba(22,78,85,0.18)] lg:max-h-[80vh] lg:w-full lg:max-w-[440px] lg:object-contain" data-id="element-90" data-mp="358zoa4fn51hc" />
        </div>

        {/* CTA + trust row */}
        <div className="text-center lg:col-start-1 lg:row-start-2 lg:self-start lg:text-left" data-id="element-91" data-mp="2lla9cxssyvpj">
          <CtaButton href="#offer-details" className="w-full sm:w-auto" data-id="element-92" data-mp="s2jnvz2aw4kk">
            Get the activity kit
          </CtaButton>
          <ul className="mt-3 flex flex-wrap justify-center gap-x-5 gap-y-1.5 text-sm text-muted lg:justify-start" data-id="element-93" data-mp="najhpovn0ffj">
            {trust.map(({
            icon: Icon,
            label
          }) => <li key={label} className="flex items-center gap-1.5" data-id="element-94" data-mp="ddnf1zsf6niw">
                <Icon className="h-4 w-4 text-petrol" aria-hidden="true" data-id="element-95" data-mp="dbaq32o8vcwc" />
                {label}
              </li>)}
          </ul>
        </div>
      </Container>
    </header>;
}